import React from 'react'
import MenuHeroSection from '../../sections/MenuHeroSection/MenuHeroSection'
import MenuSection from '../../sections/MenuSection/MenuSection'
import CrewSection from '../../sections/CrewSection/CrewSection'
import FoodGalleryCarousell from '../../sections/FoodGalleryCarousell/FoodGalleryCarousell'
import ReservationSection from '../../sections/ReservationSection/ReservationSection'

const MenuPage = () => {
  return (
    <div>
        <MenuHeroSection/>
        <MenuSection/>
        <CrewSection/>
        <FoodGalleryCarousell/>
        <ReservationSection/>
    </div>

  )
}

export default MenuPage